import { useEffect, useState } from 'react'

export const useTimerSeconds = () => {
  const [elapsedSeconds, setElapsedSeconds] = useState(0)
  useEffect(() => {
    const intervalId = setInterval(() => {
      setElapsedSeconds(t => t + 1)
    }, 1000)

    return () => {
      clearInterval(intervalId)
    }
  }, [])

  return elapsedSeconds
}
